import { useMemo } from "react";
import { useParams } from "react-router-dom";

/**
 * Парсит обязательный числовой route-параметр.
 * @throws если параметр отсутствует или не является конечным числом
 */
export function parseRequiredRouteNumberParam(paramLabel: string, rawValue: string | undefined): number {
    if (rawValue == null) {
        throw new Error(`В URL не определён ${paramLabel}`);
    }

    const parsed = Number(rawValue);
    if (!Number.isFinite(parsed)) {
        throw new Error(`Некорректное значение ${paramLabel} в URL`);
    }

    return parsed;
}

/**
 * Читает обязательный числовой параметр из `useParams`.
 */
export function useRequiredNumberParam(paramName: string, paramLabel?: string): number {
    const params = useParams();
    const rawValue = params[paramName];

    return useMemo(
        () => parseRequiredRouteNumberParam(paramLabel ?? paramName, rawValue),
        [paramLabel, paramName, rawValue],
    );
}
